import { useEffect, useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { DrawerWrapper } from "@/comps/DrawerWrapper";
import { createNiceModal } from "@/utils/nicemodel";
import { VirtualKeyboard } from "@/comps/VirtualKeyboard";
import { CheckTag } from "@/comps/CheckTag";
import { spinnerKey } from "@/utils/spinner";

export const openNumberInputModal = createNiceModal<
  {
    title: string;
    value?: string;
    prefix?: React.ReactNode;
    validator?: (value?: string) => Promise<void>;
  },
  { value?: string }
>(({ _modal, title, value, prefix, validator }) => {
  const [number, setNumber] = useState(value);

  useEffect(() => {
    setNumber(value);
  }, [_modal.props.isOpen]);

  return (
    <DrawerWrapper {..._modal.props} title={title}>
      <div className="flex flex-1 flex-col gap-y-[50px] overflow-hidden">
        <div className="px-6">
          <CheckTag
            className="h-12 w-full justify-start"
            hideActiveIcon={true}
            isActived={true}
            prefix={prefix}
          >
            {number}
          </CheckTag>
        </div>
        <VirtualKeyboard
          type="string"
          value={number}
          onChange={setNumber}
          onSubmit={async () => {
            if (validator) {
              void NiceModal.show(spinnerKey);
              try {
                await validator(number);
                _modal.resolve({ value: number });
              } finally {
                void NiceModal.hide(spinnerKey);
              }
            } else {
              _modal.resolve({ value: number });
            }
          }}
          maxLength={15}
        />
      </div>
    </DrawerWrapper>
  );
});
